export const sortObjectsNumerically =
  <T>(keyToSortBy: keyof T) =>
  (a: T, b: T): number => {
    const aName = a[keyToSortBy]
    const bName = b[keyToSortBy]
    const aNameStr = String(aName)
    const bNameStr = String(bName)
    // Check to see if the name does not contain non-numeric characters
    const aNameIsNumber = !isNaN(parseInt(aNameStr))
    const bNameIsNumber = !isNaN(parseInt(bNameStr))
    if (aNameIsNumber && bNameIsNumber) {
      const aNumber = parseInt(aNameStr)
      const bNumber = parseInt(bNameStr)

      if (aNumber - bNumber === 0) {
        // if both are the same number, sort alphabetically, or its a tie
        return aNameStr.localeCompare(bNameStr)
      }
      // if both start with numbers, sort by the number
      // If they're not the same number, sort by the number
      return parseInt(aNameStr) - parseInt(bNameStr)
    }
    if (aNameIsNumber) {
      return -1
    }
    if (bNameIsNumber) {
      return 1
      // if both are strings, localeCompare will sort them alphabetically
    }
    if (typeof aName === 'string' && typeof bName === 'string') {
      return aName.localeCompare(bName)
    }
    // bc !isNaN(null) === true, we sometimes hit this block
    return 0
  }
